import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import PropTypes from 'prop-types';
import { Component } from 'react';

/**
 * A utility component for showing and hiding content.
 *
 * @since 4.1.0
 */
export var Collapsible = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Collapsible, _Component);
  function Collapsible(props) {
    var _this;
    _this = _Component.call(this, props) || this;
    _this.toggle = function () {
      _this.setState(function (prevState) {
        return {
          collapsed: !prevState.collapsed
        };
      });
    };
    _this.state = {
      collapsed: props.defaultCollapsed
    };
    return _this;
  }
  var _proto = Collapsible.prototype;
  _proto.render = function render() {
    return this.props.children(this.state.collapsed, this.toggle);
  };
  return Collapsible;
}(Component);
Collapsible.propTypes = process.env.NODE_ENV !== "production" ? {
  /** `true` if the content should be collapsed to start with */
  defaultCollapsed: PropTypes.bool,
  /**
   * A render prop that receives two arguments:
   *     `collapsed`: the current collapsed state,
   *     `toggle`: a callback for when to toggle the collapsed state
   */
  children: PropTypes.func.isRequired
} : {};
Collapsible.defaultProps = {
  defaultCollapsed: false
};